var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLaptop === 1)?_c('Header'):(_vm.isLaptop === 2 && _vm.showHeader && _vm.isValidRoute)?_c('MobileHeader'):_vm._e(),_c('AppMain'),(_vm.isLaptop === 1 && _vm.userID)?_c('Sidebar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }